<script lang="ts">
	import type { Snippet } from 'svelte';
	import type { ClassValue } from 'svelte/elements';

	let { children, class: className }: { children: Snippet; class?: ClassValue } = $props();
</script>

<h1 class={['text-2xl font-bold md:text-3xl', className]}>
	{@render children()}
</h1>
